import { useState, useEffect } from "react";
import { useFormik } from "formik";
import * as Yup from "yup";
import { useLogin } from "../../store/query/userAuthenticationQuery";
import axios from "axios";
import { axiosInstance } from "../../utils/axiosInstance";

export const useLoginUser = () => {
  const loginMutation = useLogin();
  const [showPassword, setShowPassword] = useState(false);
  const [alert, setAlert] = useState({
    open: false,
    severity: "success",
    message: "",
  });

  const handleClose = () => {
    setAlert((prev) => ({
      ...prev,
      open: false,
    }));
  };

  const showToast = (msg, sev = "success") => {
    setAlert({
      open: true,
      severity: sev,
      message: msg,
    });
  };

  const handleLogin = (values) => {
    const { email, password } = values;
    loginMutation.mutate(
      {
        email,
        password,
      },
      {
        onError: (error) => {
          showToast("Invalid email or password", "error");
        },
      }
    );
  };

  const handleEyeButton = () => {
    setShowPassword((prev) => !prev);
  };

  const formik = useFormik({
    initialValues: { email: "", password: "" },
    onSubmit: (values) => {
      handleLogin(values);
    },
    validationSchema: Yup.object({
      email: Yup.string().email().required("Required"),
      password: Yup.string().required("Required"),
    }),
  });

  useEffect(() => {
    axiosInstance
      .get("/api/element/health")
      .then((data) => {
        console.log("API is healthy");
      })
      .catch((error) => {
        console.log(error);
      });
  }, []);

  useEffect(() => {
    axiosInstance
      .put("/api/element/health-patch")
      .then((response) => {
        console.log("API is healthy", response.data);
      })
      .catch((error) => {
        console.error(
          "Error checking API health:",
          error.response || error.message
        );
      });
  }, []);

  return {
    loginMutation,
    showPassword,
    alert,
    formik,
    handleClose,
    showToast,
    handleEyeButton,
  };
};
